/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
/* eslint-disable object-shorthand */
/* eslint-disable func-names */
window.PXUTheme.jsAwards = {
  init: function ($section) {
    // Add settings from schema to current object
    window.PXUTheme.jsAwards = $.extend(this, window.PXUTheme.getSectionData($section));

    this.createSlider($section);
    this.equalizeHeights($section);
    this.bindEvents($section);
  },
  createSlider: function ($section) {
    const $awardsSlider = $section.find('[data-awards-slider]');

    if ($awardsSlider.length === 0) {
      return;
    }

    const $prevButton = $section.find('.awards__nav--prev');
    const $nextButton = $section.find('.awards__nav--next');

    // `watchCSS` only enables the slider when the stylesheet says so, which
    // keeps the layout a plain centered grid below the slider threshold.
    const $flickitySlider = $awardsSlider.flickity({
      cellAlign: 'left',
      groupCells: false,
      wrapAround: true,
      prevNextButtons: false,
      pageDots: this.show_navigation_dots,
      watchCSS: true,
      imagesLoaded: true,
      adaptiveHeight: false,
    });

    $flickitySlider.on('settle.flickity', () => $flickitySlider.flickity('resize'));
    $prevButton.on('click', () => $flickitySlider.flickity('previous'));
    $nextButton.on('click', () => $flickitySlider.flickity('next'));
  },
  // Cells can't be sized with height: 100% — Flickity measures them to size its
  // own viewport, so the tallest card is measured here and applied to them all.
  equalizeHeights: function ($section) {
    const $cards = $section.find('.awards__card');

    if ($cards.length === 0) {
      return;
    }

    // Buttons first: a translation that wraps onto two lines changes the card
    // height, so they have to be settled before the cards are measured.
    this.equalize($section.find('.awards__button-wrapper .button'));
    this.equalize($cards);

    const $slider = $section.find('.awards__list.flickity-enabled');

    if ($slider.length > 0) {
      $slider.flickity('resize');
    }
  },
  // Clears any previous value before measuring, so this can run on every resize
  equalize: function ($elements) {
    if ($elements.length === 0) {
      return;
    }

    $elements.css('min-height', '');

    let tallest = 0;

    $elements.each(function () {
      tallest = Math.max(tallest, $(this).outerHeight());
    });

    if (tallest > 0) {
      $elements.css('min-height', tallest + 'px');
    }
  },
  bindEvents: function ($section) {
    const namespace = '.awards-' + $section.attr('id');
    let resizeTimer;

    $(window).on('resize' + namespace, () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => this.equalizeHeights($section), 250);
    });

    // Images are lazy loaded, so re-measure once everything has settled
    $(window).on('load' + namespace, () => this.equalizeHeights($section));

    // The theme only wires up `blockSelect` for its own sections, so this
    // section listens for the theme editor event itself.
    $(document).on('shopify:block:select' + namespace, (event) => {
      if ($section.attr('id') !== 'shopify-section-' + event.detail.sectionId) {
        return;
      }

      this.blockSelect($section, event.detail.blockId);
    });
  },
  blockSelect: function ($section, blockId) {
    const $awardsSlider = $section.find('.awards__list.flickity-enabled');

    if ($awardsSlider.length === 0) {
      return;
    }

    const slideIndex = $section.find('[data-awards-block-id="' + blockId + '"]').data('awards-index');

    if (typeof slideIndex !== 'undefined') {
      $awardsSlider.flickity('selectCell', slideIndex);
    }
  },
  unload: function ($section) {
    const namespace = '.awards-' + $section.attr('id');
    const $slider = $section.find('.flickity-enabled');

    $slider.flickity('destroy');
    $section.find('.awards__card, .awards__button-wrapper .button').css('min-height', '');
    $(window).off('resize' + namespace).off('load' + namespace);
    $(document).off('shopify:block:select' + namespace);
    $section.find('.awards__nav--prev').off();
    $section.find('.awards__nav--next').off();
  },
};

/******/ })()
;
